import { Model } from '@vuex-orm/core'
import Load from './Load'
import Opening from './Opening'

export default class Slab extends Model {
  static entity = 'slabs'

  static fields () {
    return {
      id: this.string(''),
      project_id: this.string(''),
      sequence: this.number(1),
      name: this.string('Plate 1'),
      length: this.number(4820),
      support_left: this.number(80),
      support_right: this.number(80),
      support_material_id: this.number(2),
      floor_width: this.number(1200),
      floor_thickness: this.number(265),
      floor_product_type_id: this.number(1),
      building_categ_id: this.number(2),
      consequence_id: this.number(2),
      fire_resistance: this.number(60),
      environment_id: this.number(1),
      open_canals_no: this.number(0),
      open_canals_reinf_diameter: this.number(8),
      deflection_limit: this.number(250),
      topping_thickness: this.number(40),
      topping_concrete_id: this.number(2),
      topping_roughness_id: this.number(1),
      date_add: this.string(''),
      date_last_save: this.string(''),
      calculation_busy: this.number(0), // calculation in progress
      calculation_date: this.string(''),
      calculation_result: this.number(null),
      calculation_pdf: this.string(''),
      calculation_error: this.string(''),
      loads: this.hasMany(Load, 'slab_id'),
      openings: this.hasMany(Opening, 'slab_id'),
      // extra: needed for other purposes
      savedOnServer: this.boolean(false),
      deleteFromServer: this.boolean(false)
    }
  }

  isLocked () {
    return !!(this.calculation_pdf || this.calculation_busy)
  }
}



// WEBPACK FOOTER //
// ./src/store/models/Slab.js